var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-overlay',[_c('VProgressCircular',{attrs:{"indeterminate":"","size":"64"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }